/* eslint-disable static-service/require-nltext-is-translated */
import * as React from "react";

const AdvocateLanguage = {
    ar: {
        copy: (
            <div>
                أكاديمية خان هي منظمة غير ربحية تهدف لنشر العلم الأكاديمي للجميع
                مستخدمة أساليب تعليمية تُعد الأكثر تطوراً. وتوفر الأكاديمية
                مصادر نظرية مجانية تم تحضيرها على مستوى تعليمي عالمي، وهي بذلك
                تعد السباقة في هذا المجال.
                <br />
                <br />
                وبالإضافة الى الفيديوهات المتوفرة باللغة الإنجليزية تقوم
                الأكاديمية حالياً بالعمل على ترجمة الفيديوهات المذكورة الى جميع
                لغات العالم. و يمكنكم الإطلاع على الفيديوهات التي تمت ترجمتها
                الى العربية وجميع اللغات الأخرى من خلال الرابط:
                {"www.khanacademy.org/contribute"}ومن ثم اختيار اللغة و الموضوع.
                <br />
                <br />
                كما يمكنكم الإطلاع على كيفية الإستفادة من مراجع أكاديمية خان في
                نطاق أوسع كإستخدام الفيديوهات ضمن المناهج التعليمية في المدارس
                والجامعات من خلال زيارة:{" "}
                <a href="https://international.khanacademy.org">
                    {"https://international.khanacademy.org"}
                </a>
                <br />
                <br />
                مقابلة مع السيد/ سلمان خان مؤسس الأكاديمية على قناة سي إن إن عن
                الدور الذي يلعبه تطوير المناهج التعليمية في تحقيق النهضة
                الفكرية:{" "}
                <a href="https://www.youtube.com/watch?v=zxJgPHM5NYI">
                    {"https://www.youtube.com/watch?v=zxJgPHM5NYI"}
                </a>
                <br />
                <br />
                *ساهم في الترجمة "مؤسسة شركاء في التنمية المستدامة -فلسطين"
            </div>
        ),
    },
    el: {
        copy: (
            <div>
                Το σχολείο σας κλείνει ή προετοιμάζει σχέδια για κλείσιμο λόγω
                του κοροναϊού (COVID-19); Λάβετε βοήθεια{" "}
                <a href="https://khanacademy.zendesk.com/hc/articles/360040167432-How-can-Khan-Academy-be-used-for-remote-learning-during-school-closures-">
                    εδώ
                </a>
                .
                <br />
                <br />Η Khan Academy είναι ένας μη κερδοσκοπικός οργανισμός με
                στόχο την αλλαγή της εκπαίδευσης προς το καλύτερο, με την δωρεάν
                παροχή παγκοσμίου επιπέδου εκπαίδευσης για οποιονδήποτε και
                οπουδήποτε. Εκτός από τα βίντεο που παρουσιάζονται παρακάτω,
                υπάρχουν πρωτότυπα αγγλικά βίντεο στον κύριο χώρο της
                ιστοσελίδας (
                <a href="https://www.khanacademy.org/">
                    {"https://www.khanacademy.org/"}
                </a>
                ), τα οποία έχουν υπότιτλους στα ελληνικά. Για να επιλέξετε τα
                βίντεο που έχουν ήδη ελληνικούς υπότιτλους, χρησιμοποιήστε το
                φίλτρο στο www.khanacademy.org/contribute. Αν θέλετε να
                συμμετάσχετε στην επέκταση της προσπάθειας μας και της Ακαδημίας
                στα ελληνικά, επισκεφθείτε επίσης την ιστοσελίδα{" "}
                <a href="https://international.khanacademy.org">
                    {"https://international.khanacademy.org"}
                </a>
                .
                <br />
                <br />
                Εκπρόσωπος: Chris Vaios
            </div>
        ),
    },
    fa: {
        copy: (
            <div>
                خان آکادمی موسسه ای غیر انتفاعی با هدف بهبود آموزش می باشد.
                آرمان این موسسه فراهم کردن آموزش رایگان و با کیفیت برای همه، در
                هر مکان می باشد.
                <br />
                <br />
                علاوه بر ویدیوهای ترجمه شده که در زیرآمد است، شما می توانید
                ویدیوهای انگلیسی خان آکادمی را که به فارسی ترجمه شده اند در سایت
                اصلی مشاهده کنید. برای مشاهده این که چه ویدیوهایی ترجمه شده اند
                می توانید از فیلتر موجود در این صفحه استفاده کنید:
                <br />
                <a href="https://www.khanacademy.org/contribute">
                    {"https://www.khanacademy.org/contribute"}
                </a>
                .
                <br />
                <br />
                : اگر شما هم علاقمند به همکاری با خان آکادمی در راستای گسترش
                دسترسی به آموزش با کیفیت می باشید. می توانید از این صفحه دیدن
                کنید
                <br />
                <a href="https://international.khanacademy.org">
                    {"https://international.khanacademy.org"}
                </a>
                <br />
                <br />
                علاوه بر این صفحه ، برای مشاهده ویدیوهای فارسی و بحث و گفت وگو
                با سایر مخاطبین فارسی زبان همچنین می توانید به
                <br />
                <br />
                نماینده : شیما سالهی
            </div>
        ),
    },
    "fa-af": {
        copy: (
            <div>
                {" "}
                <br />
                <br />
                خان اکادمی یک مؤسسهٌ است دارای وظیفهٌ مشخص. ما برای منفعت
                کارنمیکنیم وهدف ما بهبود تعلیم توسط ارائهٔ رایگان آن که دارای
                کیفیت عالی جهانی میباشد, برای هریک در همه جاست. در پهلوی
                فیدیوهای که در پایین ذکر شده است, فیدیو های اصلی هم بانوشتهٔ دری
                در صفحهٔ عمومی وجود دارد. اگر خواهان کمک درین مجادله هستید,
                لطفا" به صفحهٔ{" "}
                <a href="https://khanacademy.org/contribute">
                    {" "}
                    khanacademy.org/contribute
                </a>{" "}
                مراجعه کنید. برای معلومات بیشتر به صفحهٔ{" "}
                <a href="https://international.khanacademy.org">
                    {" "}
                    international.khanacademy.org
                </a>{" "}
                رجوع کنید. برنامهٔ مکمل در صفحهٔ{" "}
                <a href="https://www.khanacademy.org"> khanacademy.org</a> موجود
                میباشد. ترجمهٔ دروس اکادمی خان به زبان دری, توسط کمک مالی
                ورهنمود Trust in Education اجراّ شده است.
                <br />
                <br />
            </div>
        ),
    },
    he: {
        copy: (
            <div>
                אקדמית קהאן הינה ארגון ולו משימה. אנו ארגון ללא מטרת רוח שיעדו
                לשנות ולהטיב את החינוך באמצעות הענקת חינוך ברמה גבוהה לכל אחד
                ואחת ובכל מקום.
                <br />
                בנוסף לסרטונים הנמנים להלן, קיימים גם סרטונים באתר המרכזי שהוספו
                להם כתוביות בעברית. בכדי לבחור אותם השתמשו במסנן ב:{" "}
                <a href="https://www.khanacademy.org/contribute">
                    {"https://www.khanacademy.org/contribute"}
                </a>
                . עם זאת עיקר עבודתנו היא בהסבה מלאה לעברית, הכוללת תרגום
                הכתוביות ודיבוב הסרטים ושניתן להגיע אליהם באמצעות הפורטל:{" "}
                <a href="https://www.hebrewkhan.org">
                    {"https://www.hebrewkhan.org"}
                </a>{" "}
                וכן הסבה לעברית של תוכנת התרגול. אם ברצונכם להיות מעורבים בהרחבת
                הנגישות לאקדמית קהאן, בקרו ב:{" "}
                <a href="https://international.khanacademy.org">
                    {"https://international.khanacademy.org"}
                </a>
            </div>
        ),
    },
    ms: {
        copy: (
            <div>
                Khan Academy merupakan sebuah organisasi yang sedang berada
                didalam suatu misi. Kami merupakan sebuah organisasi bukan untuk
                keuntungan yang mensasarkan perubahan dalam sistem pembelajaran
                dengan menghasilkan pembelajaran secara percuma yg bertaraf
                dunia kepada semua lapisan masyarakat. Selain daripada
                video-video yang dipaparkan, terdapat juga video-video asli
                (yang dihasilkan dalam Bahasa Inggeris) di dalam laman utama
                bersama dengan sari kata bahasa Malaysia. Bagi memilih video
                yang telah mempunyai sari kata gunakan pautan tapisan di{" "}
                <a href="https://www.khanacademy.org/contribute">
                    {"https://www.khanacademy.org/contribute"}
                </a>
                . Sekiranya anda ingin memperluaskan akses Khan Academy, sila
                lawati.
                <br />
                <br />
                Di Malaysia, EduNation Malaysia merupakan pengokong rasmi bagi
                Khan Academy. Matlamat EduNation Malaysia adalah untuk
                menghasilkan video-video pembelajaran percuma bagi masyarakat di
                Malaysia dengan mengikuti sukatan pelajaran KBSR dan KBSM.
                EduNation Malaysia juga telah berkerjasama dengan 1Malaysia
                Development Berhad (1MDB) bagi menterjemah video-video dari Khan
                Academy. Lawati laman sesawang {"https://www.1mdb.com.my/"} bagi
                mengetahui dengan lebih lanjut tentang EduNation Malaysia dan
                1MDB.
            </div>
        ),
    },
    sw: {
        copy: (
            <div>
                Khan Academy ni shirika lenye lengo kuu la kuboresha elimu.
                Tovuti hii inawaletea masomo yenye mada tofauti kutumia video,
                maelezo yakiwa kwa lugha ya Kiswahili.
                <br />
                <br />
                Mbali na kanda za video ambazo zimeorodheshwa hapa, kuna kanda
                asili za kiingereza ambazo zimeongezwa mada ndogo (subtitles) za
                kiswahili. Kuchagua kanda zilizo na tafsiri unayoitaka,
                tafadhali tumia kichunjio{" "}
                <a href="https://www.khanacademy.org/contribute">
                    {"https://www.khanacademy.org/contribute"}
                </a>
                .
                <br />
                <br />
                Khan Academy shirika ambalo halitarajii kujinufaisha kwa
                vyovyote kwa kutoa elimu ya hali ya juu, na mazoezi yanapatikana
                bila malipo. Kama ungependa kushiriki katika kuendeleza huduma
                ya Khan Academy, tembelea wavuti{" "}
                <a href="https://international.khanacademy.org">
                    {"https://international.khanacademy.org"}
                </a>
                .
            </div>
        ),
    },
    te: {
        copy: (
            <div>
                ఖాన్ అకాడమీ ఒక స్వచ్చంద్ధ సేవా సంస్థ గా ప్రారంభిచబడి ప్రతి
                ఒక్కరికి నాణ్యత తో కూడిన ప్రపంచ స్థాయి విద్యను ఉచితంగా
                అందిచాలన్నదే మా సంస్థ లక్ష్యం. ఇక్కడ తెలుగు లో పొందుపరచడమైన
                వీడియోలే కాకుండా ఇతర వీడియోల కొరకు ఖాన్ అకాడమీ మెయిన్ వెబ్ సైట్
                కొరకై{" "}
                <a href="https://www.khanacademy.org/contribute">
                    {"https://www.khanacademy.org/contribute"}
                </a>{" "}
                క్లిక్ చేయండి. మీరూ ఈ ప్రయత్నం లో పాలు పంచుకోవాలంటే{" "}
                <a href="https://international.khanacademy.org">
                    {"https://international.khanacademy.org"}
                </a>{" "}
                క్లిక్ చేయండి. <br />
                <br />ఈ మహత్తర యఙం లో పాలు పంచుకుంటున్న ప్రతి ఒక్కరికి ఖాన్
                అకాడమీ తరుపున కృతఙతలు. Cigniti Technologies (
                <a href="https://www.cigniti.com">
                    {"https://www.cigniti.com"}
                </a>
                ) మరియు Gouthama High School వారికి ప్రత్యేక కృతఙతలు.
                <br />
                అడ్వకేట్ : డాక్టర్ కంది శరత్ చంద్ర.
            </div>
        ),
    },
    th: {
        copy: (
            <div>
                คาน อะคาเดมี่ เป็นองค์กรที่มุ่งมั่นในการดำเนินการตามพันธกิจ
                เราเป็นองค์กรไม่แสวงผลกำไรโดยมีเป้าหมายในการพัฒนาการศึกษาให้ดียิ่งขึ้นด้วยการให้การศึกษาในระดับชั้นนำสำหรับทุกคนไม่ว่าที่ไหนโดยไม่คิดมูลค่าใดๆทั้งสิ้น
                <br />
                นอกเหนือจากวีดีโอตามรายการด้านล่างแล้ว
                เรายังมีวีดีโอต้นฉบับที่ได้รับการแปลเป็นภาษาไทยบนเวบไซต์หลักอีกด้วย
                ในการเลือกวีดีโอที่ได้รับการแปลภาษาแล้ว
                คุณสามารถใช้ฟิลเตอร์ได้ที่{" "}
                <a href="https://www.khanacademy.org/contribute">
                    {"https://www.khanacademy.org/contribute"}
                </a>{" "}
                ถ้าหากคุณต้องการมีส่วนร่วมในการขยายโอกาสเพื่อเข้าถึงแหล่งข้อมูลของคาน
                อะคาเดมี่ คุณสามารถดูรายละเอียดได้ที่{" "}
                <a href="https://international.khanacademy.org">
                    {"https://international.khanacademy.org"}
                </a>
            </div>
        ),
    },
    uk: {
        copy: (
            <div>
                Khan Academy (Академія Хана) здійснює важливу місію. Ми –
                некомерційна організація, яка намагається зробити освіту кращою,
                надаючи через інтернет безкоштовні та якісні знання всім та
                усюди.
                <br />
                <br />
                Якщо ви хочете взяти участь у популяризації матеріалів та
                допомогти Khan Academy, будь ласка, завітайте на сторінку{" "}
                <a href="https://www.khanacademy.org/contribute">
                    {"https://www.khanacademy.org/contribute"}
                </a>
                .
            </div>
        ),
    },
    ur: {
        copy: (
            <div>
                خان اکیڈمی ایک اعلی مقصد کے حصول کے لیے وجود میں آءی ہے۔ ہم ایک
                ایسا فلاحی ادارہ ہیں جس کا خواب ہے کہ دنیا کے ہر فرد کو تعلیم کے
                بہترین مواقع، مفت حاصل ہوں۔
                <br />
                <br />
                درج ذیل ویڈیو اسی خواب کی تعبیر حاصل کرنے کی کوشش میں بناءے گءے
                ہیں۔ ان ویڈیو کے علاوہ ہماری ویب ساءٹ پر ترجمے کے ساتھ اردو سب
                ٹاءٹل یہاں دستیاب ہیں۔
                <a href="https://www.khanacademy.org/contribute">
                    {"https://www.khanacademy.org/contribute"}
                </a>
                <br />
                اگر آپ خان اکیڈمی کی مدد کرنا چاہتے ہیں تو براءے مہربانی درج ذیل
                کا دورہ کیجیے۔
                <br />
                <a href="https://international.khanacademy.org">
                    {"https://international.khanacademy.org"}
                </a>
            </div>
        ),
    },
    xh: {
        copy: (
            <div>
                I-Khan Academy ngumanyano ozibona enobizo. Injongo ye-Khan
                Academy ayiyokuba yenze imali - yeyokuba yenze utshintsho oluhle
                kwimfundo elizweni kwaye yenze ukuba wonke umntu naphi na akwazi
                ufikelela kwimfundo ekumngangatho ophezulu njengowelizwe
                jikelele. Ngaphandle kwezi zisezantsi, ezinye i-video ezizoqobo
                ziyafumaneka kwinxuwa ye-Khan Academy. Ukufumana ii-video
                ezinawo namagama wolandela, yiya kwelinxuwa:{" "}
                <a href="https://www.khanacademy.org/contribute">
                    {"https://www.khanacademy.org/contribute"}
                </a>
                <br />
                <br />
                Ukuba ufuna ukuzidibanisa nalento yenzwa yi-Khan Academy, yiya
                ku{" "}
                <a href="https://international.khanacademy.org">
                    {"https://international.khanacademy.org"}
                </a>
                <br />
                <br />
                Inguqulo yezi-video usuka kwiSilungu uyotsho kwisiXhosa
                uyiphathelwe yiYunivesithi yaseKapa idibane no-Numeric kwaye
                no-ClickMaths.
                <br />
                <br />
                Advocate: Adrian Cox
                <br />
                Email:{" "}
                <a href="mailto:info@clickmaths.org">info@clickmaths.org</a>
            </div>
        ),
    },
    zu: {
        copy: (
            <div>
                IKhan Academy iyinhlangano enonhloso. Siwumkhakha ongenzi inzuzo
                kodwa onenhloso yokuthuthukisa izinga lemfundo, ngokunikezela
                simahla imfundo eseqopheni eliphezulu ezweni kuwonke umuntu
                nomakukuphi. Ama-Video owabona lana akusiwo wodwa esinawo,
                akhona amanye ashiqilelwe olimini lweSizulu kuyona i-main site
                yethu.
                <br />
                <br />
                Ukusiza kulomzamo ungavakashela ku:{" "}
                <a href="https://khanacademy.org/r/applytotranslate">
                    {"https://khanacademy.org/r/applytotranslate"}
                </a>
                .
                <br />
                <br />
                Ukwazi kangcono ngalokhu esikwenzayo ungavakashela ku:{" "}
                <a href="https://international.khanacademy.org">
                    {"https://international.khanacademy.org"}
                </a>
                .
                <br />
                <br />
                Wonke Umsebenzi owenziwa yilenhlangano utholakala ku:{" "}
                <a href="https://www.khanacademy.org/">khanacademy.org</a>
                .
                <br />
                <br />
                Omele isiZulu:{" "}
                <a href="mailto:Duma@clickmaths.org">Dumazile Chauke</a>
            </div>
        ),
    },
} as const;

type Props = {
    kaLocale: string;
};

export default class AdvocateMessageLiteHomepage extends React.Component<Props> {
    render(): React.ReactNode {
        return (
            <div id="advocate-message">
                {this.props.kaLocale &&
                    AdvocateLanguage[this.props.kaLocale] &&
                    AdvocateLanguage[this.props.kaLocale].copy}
            </div>
        );
    }
}
